import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Form, Col, Row, Button } from '_zari/core'

import { TiposImportacionAsientos } from 'constants/index'

import { DownloadAxiosFile } from 'utils'

import * as AsientosContablesService from 'services/asientosContables.service'

import * as Modals from './modals'

const MainPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [tipoImportacionSeleccionado, setTipoImportacionSeleccionado] = React.useState('')

  const [mostrarRegistroVentasModal, setMostrarRegistroVentasModal] = React.useState(false)
  const [mostrarRegistroComprasModal, setMostrarRegistroComprasModal] = React.useState(false)
  const [mostrarCargaDiarioModal, setMostrarCargaDiarioModal] = React.useState(false)

  const clickDescargarPlantilla = React.useCallback(() => {
    let funcionDescarga = null
    let nombreArchivo = ''

    if (tipoImportacionSeleccionado === TiposImportacionAsientos.REGISTRO_VENTAS) {
      funcionDescarga = AsientosContablesService.descargaPlantillaRegistroVentas
      nombreArchivo = 'Plantilla registro de ventas.xlsx'
    } else if (tipoImportacionSeleccionado === TiposImportacionAsientos.CARGA_DIARIO) {
      funcionDescarga = AsientosContablesService.descargaPlantillaImportacionCargaDiario
      nombreArchivo = 'Plantilla importacion de diario.xlsx'
    } else if (tipoImportacionSeleccionado === TiposImportacionAsientos.REGISTRO_COMPRAS) {
      funcionDescarga = AsientosContablesService.descargaPlantillaRegistroCompras
      nombreArchivo = 'Plantilla registro de compras.xlsx'
    } else {
      __zariContext.snack('warning', 'Seleccionar tipo documento a importar.')
      return
    }

    funcionDescarga()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, nombreArchivo)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, tipoImportacionSeleccionado])

  const clickContinuar = React.useCallback(() => {
    if (tipoImportacionSeleccionado === TiposImportacionAsientos.REGISTRO_VENTAS) {
      setMostrarRegistroVentasModal(true)
    } else if (tipoImportacionSeleccionado === TiposImportacionAsientos.CARGA_DIARIO) {
      setMostrarCargaDiarioModal(true)
    } else if (tipoImportacionSeleccionado === TiposImportacionAsientos.REGISTRO_COMPRAS) {
      setMostrarRegistroComprasModal(true)
    } else {
      __zariContext.snack('warning', 'Seleccionar tipo documento a importar.')
    }
  }, [__zariContext, tipoImportacionSeleccionado])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Importar Documentos' />
        <Portlet.Body className='zari-slim-form'>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label text='DOCUMENTO' htmlFor='select-documento' md={4} alignRightAt='md' />
                <Col md={8}>
                  <Form.Select
                    id='select-documento'
                    name='select-documento'
                    value={tipoImportacionSeleccionado}
                    onChange={e => setTipoImportacionSeleccionado(e.target.value)}
                  >
                    <option value=''>Seleccionar</option>
                    {TiposImportacionAsientos.__array.map(x => (
                      <option key={x.id} value={x.id}>
                        {x.nombre}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
              {tipoImportacionSeleccionado && (
                <Row>
                  <Col md={12} className='text-right'>
                    <Button onClick={clickDescargarPlantilla} outline>
                      Descargar plantilla
                    </Button>
                    <Button onClick={clickContinuar}>Continuar</Button>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {mostrarRegistroVentasModal && (
        <Modals.RegistroVentasModal
          show={mostrarRegistroVentasModal}
          handleClose={() => setMostrarRegistroVentasModal(false)}
        />
      )}
      {mostrarRegistroComprasModal && (
        <Modals.RegistroComprasModal
          show={mostrarRegistroComprasModal}
          handleClose={() => setMostrarRegistroComprasModal(false)}
        />
      )}
      {mostrarCargaDiarioModal && (
        <Modals.CargaDiarioModal show={mostrarCargaDiarioModal} handleClose={() => setMostrarCargaDiarioModal(false)} />
      )}
    </>
  )
}

export default React.memo(MainPage)
